import { Injectable } from '@angular/core';
import { Meta,Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoService {

  constructor(private meta: Meta,
              private title: Title) {
  }

  private setTitle( newTitle: string) {
    this.title.setTitle( newTitle );
  }

  public setMeta(title: string, description?: any){

    this.meta.updateTag(
      { name: 'description', content: description }
    );

    this.setTitle(title);
  }
}
